import { ChangeDetectionStrategy, Component, Input, OnInit, computed, signal } from '@angular/core';
import { TextStyleSize } from '@sirius/typography';

import { ArrowPosition, AttentionType } from '../_shared/types';
import { IInfoBubble, InfoBubbleTextSize } from '../_shared/models/info-bubble.model';
import { TextHtmlParagraphComponent } from '../text-html/text-html-paragraph.component';

const INFO_BUBBLE_SIZE_TO_TEXT_STYLE_SIZE: Record<InfoBubbleTextSize, TextStyleSize> = {
    small: 's',
    medium: 'm',
};

@Component({
    selector: 'sirius-info-bubble',
    templateUrl: './info-bubble.component.html',
    styleUrls: ['./info-bubble.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TextHtmlParagraphComponent],
    host: {
        '[attr.role]': '"status"',
        '[attr.aria-live]': '"polite"',
        '[class]': 'hostClass()',
    },
})
export class InfoBubbleComponent implements OnInit {
    @Input() config?: IInfoBubble;
    @Input() textHtml = '';
    @Input()
    set arrowPosition(value: ArrowPosition) {
        this._arrowPosition.set(value);
    }
    get arrowPosition(): ArrowPosition {
        return this._arrowPosition();
    }
    @Input()
    set attention(value: AttentionType) {
        this._attention.set(value);
    }
    get attention(): AttentionType {
        return this._attention();
    }
    @Input()
    set textSize(value: InfoBubbleTextSize) {
        this._textSize.set(value);
    }
    get textSize(): InfoBubbleTextSize {
        return this._textSize();
    }

    private readonly _arrowPosition = signal<ArrowPosition>('none');
    private readonly _attention = signal<AttentionType>('neutral');
    private readonly _textSize = signal<InfoBubbleTextSize>('medium');

    protected readonly textStyleSize = computed<TextStyleSize>(
        () => INFO_BUBBLE_SIZE_TO_TEXT_STYLE_SIZE[this._textSize()]
    );

    protected readonly hostClass = computed(
        () => `sir-attention-${this._attention()} sir-arrow-position-${this._arrowPosition()}`
    );

    ngOnInit(): void {
        if (this.config) {
            this.textHtml = this.config.textHtml;
            this.attention = this.config.attention;
            this.arrowPosition = this.config.arrowPosition;
            this.textSize = this.config.textSize;
        }
    }
}
